/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Test_user = {
    readonly firstName: string;
    readonly lastName: string;
    readonly " $refType": "Test_user";
};
export type Test_user$data = Test_user;
export type Test_user$key = {
    readonly " $data"?: Test_user$data;
    readonly " $fragmentRefs": FragmentRefs<"Test_user">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "Test_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastName",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '9d42a208c03ee9c8fc948bdb4a88b0e8';
export default node;
